import { render, staticRenderFns } from "./VNavButton.vue?vue&type=template&id=4732f018&scoped=true"
import script from "./VNavButton.vue?vue&type=script&lang=js"
export * from "./VNavButton.vue?vue&type=script&lang=js"
import style0 from "./VNavButton.vue?vue&type=style&index=0&id=4732f018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4732f018",
  null
  
)

export default component.exports